import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lifx = defineConnector({
  identifier: "lifx",
  name: "LIFX",
  tagLine: "Wi-Fi smart lighting",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.lifx\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in at https://cloud.lifx.com/settings, then under “Personal access tokens” generate a new token. Copy it now, because it’s shown only once.",
        },
      ],
    },
    {
      title: "Paste your access token below",
      items: [
        {
          kind: "input",
          label: "LIFX personal access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.lifx.com/v1/lights/all",
  },
});
